import React from "react";
import { useT } from "@/i18n/I18nContext";
import MilestoneOverlay from "./MilestoneOverlay";

// Direct locale copy — the i18n helper returns the key path when a key
// is missing, so we can't rely on a `|| "…"` fallback. Ship the four
// languages here so this celebration is guaranteed to render clean.
const COPY = {
  it: "2 L raggiunti! 💧",
  en: "2 L reached! 💧",
  de: "2 L geschafft! 💧",
  fr: "2 L atteints ! 💧",
};

/**
 * Water 2 L celebration overlay — thin wrapper around `MilestoneOverlay`
 * that pre-fills the transparent water mascot + localized headline.
 * Frequency-once-per-day is handled by the Dashboard via
 * `localStorage["water_2l_shown_YYYY-MM-DD"]`.
 */
export default function WaterMilestone2LOverlay({ show, onClose }) {
  const { lang } = useT();
  const title = COPY[lang] || COPY.it;
  return (
    <MilestoneOverlay
      show={show}
      onClose={onClose}
      mascotSrc="/mascot/water-2l-512.png"
      mascotAlt="Solano"
      title={title}
      confettiColors={["#5FB3D8", "#7ECEE5"]}
      testId="water-2l-overlay"
    />
  );
}
